/* Store za obvestila o novih dokumentih (zvonec + znacke).
   [PATCH obvestila-dokumenti v1] — glej NACRT_obvestila-novi-dokumenti_v3_20260713.md */
import { create } from 'zustand';
import { api } from '../lib/api';

export interface ObvestiloVnos {
  company_id: string;
  company_name: string;
  zavihek: string;
  zavihek_label: string;
  st_dokumentov: number;
  razclenitev: Record<string, number>;
  zadnji_ob: string;
}

interface ObvestilaState {
  vnosi: ObvestiloVnos[];
  nalozi: () => Promise<void>;
  oznaciVideno: (companyId: string, zavihek: string) => Promise<void>;
}

export const useObvestilaStore = create<ObvestilaState>((set, get) => ({
  vnosi: [],
  nalozi: async () => {
    try {
      const r = await api.get('/obvestila/dokumenti');
      set({ vnosi: Array.isArray(r.data) ? r.data : [] });
    } catch {
      /* tiho — naslednji poll bo poskusil znova */
    }
  },
  oznaciVideno: async (companyId, zavihek) => {
    try {
      await api.post('/obvestila/' + companyId + '/videno', { zavihek });
      await get().nalozi();
    } catch {
      /* tiho */
    }
  },
}));
